<template>
  <div>
    <grid-layout
      :layout.sync="layout"
      :col-num="12"
      :row-height="30"
      :is-draggable="true"
      :is-resizable="false"
      :is-mirrored="false"
      :use-css-transforms="true"
    >
      <grid-item
        :class="gridItemClass"
        style="padding: 10px"
        :static="true"
        :x="0"
        :y="0"
        :w="12"
        :h="10"
        :i="0"
      >
        <MultiLine
          :data="lineChartData"
          :darkmode="this.$store.state.darkmode"
        />
      </grid-item>

      <grid-item
        :class="gridItemClass"
        :static="true"
        :x="0"
        :y="10"
        :w="3"
        :h="4"
        :i="1"
      >
        <stats-card
          style="height: 100%;"
          type="info"
          color="#FFC107"
          :title="balance"
          :sub-title="$t('financial.dashboard.balance')"
          icon="tim-icons icon-money-coins"
        >
          <div slot="footer">
            <i class="tim-icons icon-coins"></i>
            {{ $t("financial.dashboard.balanceDesc") }}
            {{
              this.lineChartData.yValues[this.lineChartData.yValues.length - 1]
            }}
          </div>
        </stats-card>
      </grid-item>

      <grid-item
        :class="gridItemClass"
        :static="true"
        :x="3"
        :y="10"
        :w="3"
        :h="4"
        :i="2"
      >
        <div class="transac-card">
          <div class="transac-content">
            <div class="text">
              <h4>{{ $t("financial.dashboard.lastTransaction") }}</h4>
              <h3>{{ lastTransaction }}</h3>
            </div>
          </div>
        </div>
      </grid-item>

      <grid-item
        :class="gridItemClass"
        :static="true"
        :x="6"
        :y="10"
        :w="3"
        :h="4"
        :i="3"
      >
        <stats-card
          style="height: 100%;"
          type="success"
          color="#32CD32"
          :title="avarageIncome"
          :sub-title="$t('financial.dashboard.averageIncome')"
          icon="tim-icons icon-simple-add"
        >
          <div slot="footer">
            <i class="tim-icons icon-simple-add"></i>
            {{ $t("financial.dashboard.avarageIncomeDesc") }}
          </div>
        </stats-card>
      </grid-item>

      <grid-item
        :class="gridItemClass"
        :static="true"
        :x="9"
        :y="10"
        :w="3"
        :h="4"
        :i="4"
      >
        <stats-card
          style="height: 100%;"
          type="danger"
          color="#E53935"
          :title="avarageExpense"
          :sub-title="$t('financial.dashboard.averageExpense')"
          icon="tim-icons icon-simple-delete"
        >
          <div slot="footer">
            <i class="tim-icons icon-simple-delete"></i>
            {{ $t("financial.dashboard.avarageExpenseDesc") }}
          </div>
        </stats-card>
      </grid-item>

      <grid-item
        :class="gridItemClass"
        style="padding: 5px 10px;"
        :static="true"
        :x="0"
        :y="14"
        :w="6"
        :h="5"
        :i="7"
      >
        <h3>{{ $t("financial.dashboard.amountsReceivable") }}</h3>
        <div class="flex-container">
          <div class="card-values">
            <h4 class="card-values-title">
              {{ $t("financial.dashboard.toReceive") }}
            </h4>
            <h3 class="card-values-value" style="color: #9CFF19;">R$308,00</h3>
          </div>
          <div class="card-values">
            <h4 class="card-values-title">
              {{ $t("financial.dashboard.salariesToday") }}
            </h4>
            <h3 class="card-values-value" style="color: #9CFF19;">R$112,00</h3>
          </div>
        </div>
      </grid-item>

      <grid-item
        :class="gridItemClass"
        style="padding: 5px 10px;"
        :static="true"
        :x="6"
        :y="14"
        :w="6"
        :h="5"
        :i="8"
      >
        <h3>{{ $t("financial.dashboard.amountsPayable") }}</h3>
        <div class="flex-container">
          <div class="card-values">
            <h4 class="card-values-title">
              {{ $t("financial.dashboard.toPay") }}
            </h4>
            <h3 class="card-values-value" style="color: #FF4619;">R$250,00</h3>
          </div>
          <div class="card-values">
            <h4 class="card-values-title">
              {{ $t("financial.dashboard.salariesToday") }}
            </h4>
            <h3 class="card-values-value" style="color: #FF4619;">R$56,00</h3>
          </div>
        </div>
      </grid-item>

      <grid-item
        :class="gridItemClass"
        style="padding: 10px"
        :static="true"
        :x="0"
        :y="19"
        :w="6"
        :h="13"
        :i="5"
      >
        <Pizza :data="pizzaChartData" :darkmode="this.$store.state.darkmode" />
      </grid-item>

      <grid-item
        :class="gridItemClass"
        style="padding: 10px;"
        :static="true"
        :x="6"
        :y="19"
        :w="6"
        :h="13"
        :i="6"
      >
        <ColumnChart
          :data="columnChartData"
          :darkmode="this.$store.state.darkmode"
        />
      </grid-item>
    </grid-layout>
  </div>
</template>

<script>
import MultiLine from "../Charts/MultiLine.vue";
import Pizza from "../Charts/Pizza.vue";
import VueGridLayout from "vue-grid-layout";
import StatsCard from "src/components/Cards/StatsCard";
import ColumnChart from "../Charts/Column.vue";

export default {
  name: "FinancialDashboard",
  components: {
    MultiLine,
    Pizza,
    ColumnChart,
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    StatsCard
  },
  data() {
    return {
      columnChartData: {
        labels: [
          "Jan",
          "Fev",
          "Mar",
          "Abr",
          "Mai",
          "Jun",
          "Jul",
          "Ago",
          "Set",
          "Out",
          "Nov",
          "Dev"
        ],
        title: "Faturamento Mensal",
        series: [
          {
            name: "Faturamento",
            data: [
              500,
              600,
              300,
              400,
              700,
              600,
              800,
              900,
              700,
              600,
              800,
              100,
              700
            ],
            color: "#4287f5"
          }
        ]
      },
      lineChartData: {
        title: "Renda x Despesas",
        yValues: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
        series1: [320, 432, 801, 740, 705, 514],
        series2: [510, 632, 587, 512, 393, 104]
      },
      pizzaChartData: {
        title: "Saldo por banco",
        series: [
          { value: 1048, name: "Bradesco" },
          { value: 735, name: "Itau" },
          { value: 580, name: "Viacredi" }
        ]
      },
      layout: [
        { x: 0, y: 0, w: 12, h: 10, i: "0" },
        { x: 0, y: 10, w: 3, h: 4, i: "1" },
        { x: 3, y: 10, w: 3, h: 4, i: "2" },
        { x: 6, y: 10, w: 3, h: 4, i: "3" },
        { x: 9, y: 10, w: 3, h: 4, i: "4" },
        { x: 0, y: 13, w: 6, h: 5, i: "5" },
        { x: 6, y: 13, w: 6, h: 5, i: "6" },
        { x: 0, y: 3, w: 6, h: 10, i: "7" },
        { x: 6, y: 3, w: 6, h: 10, i: "8" }
      ],
      index: 0,
      lastTransaction: "Novo Pagamento",
      sidebarBackground: "primary", 
      process: []
    };
  },
  created() {
    this.getAllProcess();
  },
  computed: {
    avarageIncome() {
      const { series1 } = this.lineChartData;
      if (series1.length === 0) return "R$ 0,00";
      const media =
        series1.reduce((acc, valor) => acc + valor, 0) / series1.length;
      return media.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
      });
    },
    avarageExpense() {
      const { series2 } = this.lineChartData;
      if (series2.length === 0) return "R$ 0,00"; 
      const media =
        series2.reduce((acc, valor) => acc + valor, 0) / series2.length;
      return media.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
      });
    },
    balance() {
      return this.lineChartData.series1[
        this.lineChartData.series1.length - 1
      ].toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
    gridItemClass() {
      return this.$store.state.darkmode
        ? "dark-theme-grid-item"
        : "white-theme-grid-item";
    }
  },
  methods: {
    getBalancePerMonth() {
      this.modelstate = {};
      this.$apiScheduler
        .get("")
        .then(response => {
          this.lineChartData = response.data;
        })
        .catch(error => {});
    },
    getAllProcess() {
      this.$apiWorkflow.get("/process/all/").then(response => {
        this.process = response.data;
      });
    },
    getPermission(p) {
      if (p.administrador) return true;
      if (p.gestor) return true;
      if (p.advancedOperator) return true;
      if (p.simpleOperator) return true;
      return false;
    }
  }
};
</script>

<style>
.centered-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  text-align: center;
}
.transac-card {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.transac-content {
  text-align: center;
}

.text h3 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 20px;
  font-weight: bold;
}

.text h4 {
  font-size: 18px;
  margin-bottom: 10px;
}

.flex-container {
  display: flex;
  gap: 10px;
  height: 100%;
}

.card-values {
  flex: 1;
  height: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.card-values-title {
  margin: 0 !important;
  font-size: 1rem;
}

.card-values-value {
  margin: 0 0 0 0;
  font-weight: 600;
}

.white-theme-grid-item {
  box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1);
  border: 0.1px solid #4d4d4d;
  background-color: #ffffff;
  border-radius: 4px;
}

.dark-theme-grid-item {
  box-shadow: 0 1px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
</style>
